// Arsenal: shows the user's owned Snordeluxes when the Arsenal button
// is clicked. Reuses the existing .inventory-container markup and the
// updateInventoryDisplay logic from inventory.js.

import { updateInventoryDisplay } from './inventory';

function getEl() {
    return document.querySelector('.inventory-container');
}

let escapeHandler = null;

export function showArsenal() {
    const el = getEl();
    if (!el) return;
    updateInventoryDisplay();
    el.style.display = 'flex';
    el.classList.add('arsenal-open');
    document.body.classList.add('arsenal-open');

    const close = el.querySelector('.arsenal-close');
    if (close) close.onclick = hideArsenal;

    // Click on the dark backdrop (anywhere outside the inventory card)
    el.onclick = (e) => {
        if (e.target === el) hideArsenal();
    };

    if (!escapeHandler) {
        escapeHandler = (e) => { if (e.key === 'Escape') hideArsenal(); };
        document.addEventListener('keydown', escapeHandler);
    }
}

export function hideArsenal() {
    const el = getEl();
    if (!el) return;
    el.style.display = 'none';
    el.classList.remove('arsenal-open');
    document.body.classList.remove('arsenal-open');
    if (escapeHandler) {
        document.removeEventListener('keydown', escapeHandler);
        escapeHandler = null;
    }
}
